import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const CMSContent = () => {
  const [contentBlocks, setContentBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadContentBlocks();
  }, []);

  const loadContentBlocks = async () => {
    try {
      setLoading(true);
      const response = await api.getContentBlocks();
      if (response.success) {
        setContentBlocks(response.data || []);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this content block?')) {
      return;
    }

    try {
      const response = await api.deleteContentBlock(id);
      if (response.success) {
        loadContentBlocks();
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  return (
    <>
      {error && (
        <div className="alert alert-danger alert-dismissible">
          <button type="button" className="close" onClick={() => setError('')}>&times;</button>
          {error}
        </div>
      )}

      <div className="row mb-3">
        <div className="col-md-12">
          <button className="btn btn-primary btn-sm" disabled>
            <i className="fas fa-plus"></i> New Content Block
          </button>
          <small className="ml-2 text-muted">(Coming soon)</small>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Content Blocks</h3>
            </div>
            <div className="card-body">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Page</th>
                    <th>Block Key</th>
                    <th>Status</th>
                    <th>Updated</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {contentBlocks.length > 0 ? (
                    contentBlocks.map(item => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.block_type}</td>
                        <td>{item.page_title || 'N/A'}</td>
                        <td><code>{item.block_key}</code></td>
                        <td>
                          <span className={`badge ${item.is_active ? 'bg-success' : 'bg-secondary'}`}>
                            {item.is_active ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>{new Date(item.updated_at).toLocaleDateString()}</td>
                        <td>
                          <button className="btn btn-sm btn-info mr-1" disabled>
                            <i className="fas fa-edit"></i>
                          </button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">No content blocks found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CMSContent;


